import { teamContext } from "@redotech/feature-flags-model/context";
import { featureFlag } from "@redotech/openfeature-contracts/flag";

/** Serve the rebuilt PLG home page at /home/overview instead of the legacy one. */
export const plgHomepageFlag = featureFlag("plg-homepage", teamContext).boolean(
  false,
);
